"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TermsAgreement = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
const utils_1 = require("@/utils");
require("@/components/common/checkbox");
require("@/components/common/surface");
/**
 * 약관 동의. 전체 동의 체크박스와 약관 목록을 함께 렌더하고, 선택 값은 약관 목록이 소유한다.
 * 전체 동의는 별도 컴포넌트 없이 mm-checkbox로 두고, 목록의 checked·indeterminate를 따라 표시한다.
 */
let TermsAgreement = class TermsAgreement extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.options = [];
        this.values = [];
        this.handleAllChange = (event) => {
            event.stopPropagation();
            this.group?.toggleAll();
        };
        this.handleGroupChange = (event) => {
            event.stopPropagation();
            this.values = event.detail.values;
            (0, utils_1.emit)(this, 'change', { values: this.values });
        };
    }
    render() {
        return (0, lit_1.html) `
      <mm-surface variant="elevated">
        <mm-checkbox
          size="large"
          .checked=${this.group?.checked ?? false}
          .indeterminate=${this.group?.indeterminate ?? false}
          @change=${this.handleAllChange}
        >
          <slot>모두 동의합니다.</slot>
        </mm-checkbox>
      </mm-surface>

      <mm-checkbox-group
        name=${(0, if_defined_js_1.ifDefined)(this.name)}
        size="large"
        .options=${this.options}
        .values=${this.values}
        @change=${this.handleGroupChange}
      ></mm-checkbox-group>
    `;
    }
    firstUpdated() {
        // 첫 렌더에서는 목록이 아직 없어 전체 동의 상태를 읽지 못하므로 한 번 더 그린다.
        this.requestUpdate();
    }
};
TermsAgreement.styles = (0, lit_1.css) `
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--space-3);
    }
  `;
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], TermsAgreement.prototype, "options", void 0);
__decorate([
    (0, decorators_js_1.property)({ attribute: false })
], TermsAgreement.prototype, "values", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TermsAgreement.prototype, "name", void 0);
__decorate([
    (0, decorators_js_1.query)('mm-checkbox-group')
], TermsAgreement.prototype, "group", void 0);
TermsAgreement = __decorate([
    (0, decorators_js_1.customElement)('mm-terms-agreement')
], TermsAgreement);
exports.TermsAgreement = TermsAgreement;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVybXMtYWdyZWVtZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsidGVybXMtYWdyZWVtZW50LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBa0U7QUFDbEUsZ0VBQXdEO0FBS3hELG1DQUE4QjtBQUM5Qix3Q0FBcUM7QUFDckMsdUNBQW9DO0FBRXBDOzs7R0FHRztBQUVJLElBQU0sY0FBYyxHQUFwQixNQUFNLGNBQWUsU0FBUSxnQkFBVTtJQUF2Qzs7UUFRMkIsWUFBTyxHQUFpQixFQUFFLENBQUE7UUFDMUIsV0FBTSxHQUFhLEVBQUUsQ0FBQTtRQWdDN0Msb0JBQWUsR0FBRyxDQUFDLEtBQVksRUFBRSxFQUFFO1lBQ3pDLEtBQUssQ0FBQyxlQUFlLEVBQUUsQ0FBQTtZQUN2QixJQUFJLENBQUMsS0FBSyxFQUFFLFNBQVMsRUFBRSxDQUFBO1FBQ3pCLENBQUMsQ0FBQTtRQUNPLHNCQUFpQixHQUFHLENBQUMsS0FBd0MsRUFBRSxFQUFFO1lBQ3ZFLEtBQUssQ0FBQyxlQUFlLEVBQUUsQ0FBQTtZQUN2QixJQUFJLENBQUMsTUFBTSxHQUFHLEtBQUssQ0FBQyxNQUFNLENBQUMsTUFBTSxDQUFBO1lBQ2pDLElBQUEsWUFBSSxFQUFDLElBQUksRUFBRSxRQUFRLEVBQUUsRUFBRSxNQUFNLEVBQUUsSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDLENBQUE7UUFDL0MsQ0FBQyxDQUFBO0lBQ0gsQ0FBQztJQXJDQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7OztxQkFJTSxJQUFJLENBQUMsS0FBSyxFQUFFLE9BQU8sSUFBSSxLQUFLOzJCQUN0QixJQUFJLENBQUMsS0FBSyxFQUFFLGFBQWEsSUFBSSxLQUFLO29CQUN6QyxJQUFJLENBQUMsZUFBZTs7Ozs7OztlQU96QixJQUFBLHlCQUFTLEVBQUMsSUFBSSxDQUFDLElBQUksQ0FBQzs7bUJBRWhCLElBQUksQ0FBQyxPQUFPO2tCQUNiLElBQUksQ0FBQyxNQUFNO2tCQUNYLElBQUksQ0FBQyxpQkFBaUI7O0tBRW5DLENBQUE7SUFDSCxDQUFDO0lBRUQsWUFBWTtRQUNWLGlEQUFpRDtRQUNqRCxJQUFJLENBQUMsYUFBYSxFQUFFLENBQUE7SUFDdEIsQ0FBQzs7QUF0Q00scUJBQU0sR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7O0dBTWxCLENBQUE7QUFDK0I7SUFBL0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsU0FBUyxFQUFFLEtBQUssRUFBRSxDQUFDOytDQUEyQjtBQUMxQjtJQUEvQixJQUFBLHdCQUFRLEVBQUMsRUFBRSxTQUFTLEVBQUUsS0FBSyxFQUFFLENBQUM7OENBQXNCO0FBQ3pCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzs0Q0FBYztBQUNiO0lBQTNCLElBQUEscUJBQUssRUFBQyxtQkFBbUIsQ0FBQzs2Q0FBOEI7QUFYOUMsY0FBYztJQUQxQixJQUFBLDZCQUFhLEVBQUMsb0JBQW9CLENBQUM7R0FDdkIsY0FBYyxDQWtEMUI7QUFsRFksd0NBQWMifQ==